// "Recent payments" panel on the admin dashboard. Verbatim from AdminDashboard.jsx (W2d).
export default function RecentPaymentsList({ recentPayments }) {
  return (
    <div className="sf-card" data-testid="recent-payments-card">
      <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Recent payments</div>
      {recentPayments.length === 0 && <div className="sf-muted-text" style={{ fontSize: 13 }}>No payments yet.</div>}
      {recentPayments.map((p) => (
        <div
          key={p.payment_id}
          className="sf-mono"
          style={{ fontSize: 12, padding: "8px 0", borderBottom: "1px dashed #22262B" }}
          data-testid={`recent-payment-${p.payment_id}`}
        >
          <div>${(p.amount_cents / 100).toFixed(2)} · {p.status}</div>
          <div className="sf-muted-text" style={{ fontSize: 11 }}>{p.paid_at}</div>
        </div>
      ))}
    </div>
  );
}
